define('app/editor/dialogs/SendLinkDialogView',['require','./SaveDialogView','app/app','glu/$','glu/dialog','hbs!./SendLinkDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('./SaveDialogView'),
		APP = require('app/app'),
		$ = require('glu/$'),
		dialog = require('glu/dialog');

	var view = SaveDialogView.extend({

		dialogTitle: 'Send Link',

		getClass: function() {
			return 'modal-send-link';
		},

		dialogButtons: [{
			text: 'Send Link',
			callback: 'send',
			className: 'btn-primary btn-send-link'
		}, {
			text: 'Cancel',
			callback: 'cancelCallback',
			className: 'btn-primary'
		}],

		template: require('hbs!./SendLinkDialogView.hbs'),

		ui: {
			$selectedUsers: '[name="users"]',
			$message: '#message',
			$attachCsv: '[name="attach-csv"]'
		},

		onRender: function() {
			this.ui.$selectedUsers.comboBox();
		},

		send: function() {
			var self = this,
				now = $.datepicker.formatDate('M d, yy', new Date()),
				description = self.model.getDescription(),
				content,
				payload = {},
				url,
				port;

			payload.recipients = self.$(self.ui.$selectedUsers).val();
			if (!payload.recipients) {
				return;
			}

			if (window.location.port) {
				port = ':' + window.location.port;
			} else {
				port = '';
			}

			url = window.location.protocol + '//' + window.location.hostname + port + '/analytics-ui/ui/domains/' + this.model.get('domainId') + '/reports/' + this.model.get('id');

			// Generate report content
			if (self.$(self.ui.$attachCsv).prop('checked')) {
				// Shared + Attachment
			} else {
				// Shared + No Attachment
			}


			content = 'The following report was shared with you by ' + APP.user.getUsername() + '.<br>(You can reply to this email to contact the sender)<br><br>';

			if (self.ui.$message.val()) {
				content += 'Message: <i>"' + self.ui.$message.val() + '"</i><br><br>';
			}

			content += '<b>' + self.model.getName() + '</b><br>';

			if (description && description.length > 0) {
				content += self.model.getDescription() + '<br>';
			}

			if (self.$(self.ui.$attachCsv).prop('checked')) {
				// Shared + Attachment
				content += '<a href=' + url + '>' + 'Click here to view the report' + '</a>' + '<br>' +
					'Please open the attached file to view the results of this report as of ' + now + '.<br><br>' +
					'Note: Please click the link above to login to view the shared report. The shared report is available for viewing but cannot be modified. ' +
					'Only the original owner of the report can modify the report. To modify a copy of the report, please save the report as a copy in your own dashboard.';
			} else {
				// Shared + No Attachment
				content += '<a href=' + url + '>' + 'Click here to view the report' + '</a>' + '<br><br>' +
					'Note: Please click the link above to login to view the shared report. The shared report is available for viewing but cannot be modified. ' +
					'Only the original owner of the report can modify the report. To modify a copy of the report, please save the report as a copy in your own dashboard.';
			}

			payload.sender = APP.user.getUsername();
			payload.subject = 'Analytics report: ' + self.model.getName();
			payload.messageType = 'EMAIL';
			payload.dataForm = self.$(self.ui.$attachCsv).prop('checked') ? 'CSV' : 'LINK';
			payload.reportId = self.model.id;
			payload.recipients = self.$(self.ui.$selectedUsers).val();
			payload.content = content;
			$('.btn-send-link').attr('aria-busy', true);
			self.model.sendReportLink(payload).then(function() {
				dialog.close();
				self.model.trigger('linkSent');
			});
		},

		cancelCallback: function() {
			dialog.close();
		},

		userOptions: function() {
			var users = APP.users;

			return users.map(function(user) {
				return {
					value: user.get('username'),
					label: user.get('username')
				};
			});
		}
	});

	return view;
});

